import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import simulatorTrainingRoutes from 'modules/simulatorTrainings/common/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const SimulatorList = lazy(
  () =>
    import(
      /* webpackChunkName: "SimulatorTrainingInstructorILSimulatorList" */ 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/pages/SimulatorList'
    )
)

const SimulatorListRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={routes.root} component={SimulatorList} />
      <Redirect path='*' to={simulatorTrainingRoutes.root} />
    </Switch>
  </Suspense>
)

export default SimulatorListRouting
